import {
  Button,
  Divider,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { addContactV2Style } from "./AddContactV2Style";
import {
  BUSINESS_CLASSIFICATION_OPTIONS,
  BUSINESS_TYPE_OPTIONS,
  LEAD_TYPES,
  PHONE_TYPES,
  US_STATE_LIST,
} from "../../constants/CoreConstants";
import { IconList } from "../addContact/IconList";
import { DeleteForever } from "@material-ui/icons";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { getState } from "../addContact/Utils";
import { useSelector } from "react-redux";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "./datePickerCustomStyle.css"
import { PlusIcon } from "../common/Icons";
import BasicFormControlWithLabelV2 from "../custom/BasicFormControlWithLabelV2";
import BasicSelectWithSearch from "../common/BasicSelectWithSearch";
import BasicSelect from "../custom/BasicSelect";
import {BasicMaskedInput} from "../GlobalAddDealModalV3/GlobalAddDealModalStyles";
import BasicInput from "../custom/BasicInput";
const ContactBusinessInfoTab = ({
  businessInfoRef,
  commercialContactForm,
  handleChangeDynamicInput,
  appendNumber,
  removeMultiField,
  appendEmail,
  handleInputField,
  handleAddress,
  showAddress,
  toggleAddress,
  value,
  makeAddress,
}) => {
  const { leadSourceOptions, pipelineOptions, stageOptions } = useSelector(
    (state) => state.addContactOptionReducer
  );
  const classes = addContactV2Style();
  const GOOGLE_API_KEY = process.env.REACT_APP_MAP_KEY;
  const [updatedStageOptions, setUpdatedStageOptions] = useState([]);

  useEffect(() => {
    setUpdatedStageOptions(stageOptions);
  }, [stageOptions]);

  useEffect(() => {
    const filteredStageOptions = stageOptions.filter((item) => {
      return item.pipeline_id === commercialContactForm.pipeline_id;
    });
    setUpdatedStageOptions(filteredStageOptions);
  }, [commercialContactForm.pipeline_id]);

  return (
    <div style={{ width: "100%", marginBottom: 48 }}>
      <Grid
        container
        spacing={2}
        style={{ paddingInline: 5, marginBottom: 16 }}
        ref={businessInfoRef}
        data-section="Business Info"
      >
        <Grid item xs={12}>
          <div style={{ width: "100%",  }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  paddingRight: "10px",
                }}
              >
                <Typography variant="body2" className={classes.titleStyle}>
                  Business Info
                </Typography>
              </div>

              <div style={{ width: "100%" }}>
                <Divider />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

     <div style={{ 
        width: "100%", 
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "16px",
        }}>
       <Grid container spacing={2} style={{ paddingInline: 5 }}>
        <Grid item xs={12} md={3}>
            <BasicFormControlWithLabelV2
                label={'Lead Source'}
                fullWidth
                options={leadSourceOptions}
                mapping={{
                    label: "source_title",
                    value: "id",
                }}
                defaultText="Please Select"
                placeholderText='Search lead source...'
                value={commercialContactForm.selected_source}
                onChange={(e) =>
                    handleInputField("selected_source", e.target.value)
                }
                component={BasicSelectWithSearch}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& .MuiInputBase-input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={3}>
            <BasicFormControlWithLabelV2
                label={'Lead Type'}
                fullWidth
                options={LEAD_TYPES}
                defaultText="Please Select"
                value={commercialContactForm.lead_type}
                onChange={(event) => {
                    handleInputField("lead_type", event.target.value);
                }}
                mapping={{
                    label: "label",
                    value: "value",
                }}
                component={BasicSelect}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& .MuiInputBase-input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={3}>
            <BasicFormControlWithLabelV2
                label={'Pipeline'}
                fullWidth
                name="pipeline"
                options={pipelineOptions}
                defaultText="Please Select"
                value={commercialContactForm.pipeline_id}
                onChange={(event) => {
                    handleInputField("pipeline_id", event.target.value);
                }}
                mapping={{
                    label: "title",
                    value: "id",
                }}
                component={BasicSelect}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& .MuiInputBase-input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={3}>
            <BasicFormControlWithLabelV2
                label={'Stage'}
                fullWidth
                name="stage"
                options={updatedStageOptions}
                defaultText="Please Select"
                value={commercialContactForm.stage_id}
                onChange={(event) => {
                    handleInputField("stage_id", event.target.value);
                }}
                mapping={{
                    label: "stage",
                    value: "id",
                }}
                component={BasicSelect}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& .MuiInputBase-input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={6}>
            <BasicFormControlWithLabelV2
                label={'Business Name'}
                fullWidth
                value={commercialContactForm.company_name}
                onChange={(event) =>
                    handleInputField("company_name", event.target.value)
                }
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={6}>
            <BasicFormControlWithLabelV2
                label={'DBA'}
                fullWidth
                value={commercialContactForm.dba}
                onChange={(event) => handleInputField("dba", event.target.value)}
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        {
            commercialContactForm.numbers.map((number, index) => (
               <Grid item xs={12} key={index}>
                   <Grid item xs={12}>
                       <Grid container spacing={2}>
                           <Grid item xs={6} className="mask-numbr-input">
                               <BasicFormControlWithLabelV2
                                   label={'Phone Number'}
                                   fullWidth
                                   mask={[
                                       "+",
                                       /\d/,
                                       " ",
                                       "(",
                                       /\d/,
                                       /\d/,
                                       /\d/,
                                       ")",
                                       " ",
                                       /\d/,
                                       /\d/,
                                       /\d/,
                                       "-",
                                       /\d/,
                                       /\d/,
                                       /\d/,
                                       /\d/,
                                   ]}
                                   className={`${classes.phoneNumberInput} MuiInputBase-input`}
                                   // guide={true}
                                   // keepCharPositions={true}
                                   id={"number-input-field" + index}
                                   onChange={(event) => {
                                       handleChangeDynamicInput(
                                           "numbers",
                                           "number",
                                           event.target.value,
                                           index
                                       );
                                   }}
                                   value={number.number}
                                   component={BasicMaskedInput}
                                   sx={{
                                       '& .MuiInputBase-root': {
                                           marginTop: 0,
                                       },
                                       '& input': {
                                           border: 'none !important'
                                       }
                                   }}
                               />
                           </Grid>
                           <Grid item xs={6}>
                               <div style={{ display: "flex", gap: "10px" }}>
                                   <BasicSelect
                                       fullWidth
                                       name="numberState"
                                       options={PHONE_TYPES}
                                       defaultText="Please Select"
                                       value={number.number_state}
                                       onChange={(event) => {
                                           handleChangeDynamicInput(
                                               "numbers",
                                               "number_state",
                                               event.target.value,
                                               index
                                           );
                                       }}
                                       mapping={{
                                           label: "label",
                                           value: "value",
                                       }}
                                   />
                                   {index === 0 ? (
                                       <div
                                           className={classes.addButtonStyle}
                                           onClick={appendNumber}
                                       >
                                           <PlusIcon fill="#FFF" />
                                       </div>
                                   ) : (
                                       <IconButton
                                           size="small"
                                           className=""
                                           style={{ marginLeft: "5px" }}
                                           onClick={() => {
                                               removeMultiField("numbers", index);
                                           }}
                                       >
                                           <DeleteForever color="error" />
                                       </IconButton>
                                   )}
                               </div>
                           </Grid>
                       </Grid>
                   </Grid>
               </Grid>
            ))
        }

        {
           commercialContactForm.emails.map((email, index) => (
            <Grid item xs={12} key={index}>
               <div style={{ display: "flex", gap: "10px" }}>
                   <BasicFormControlWithLabelV2
                       label={'Email Address'}
                       fullWidth
                       value={email.email}
                       onChange={(event) => {
                           handleChangeDynamicInput(
                               "emails",
                               "email",
                               event.target.value,
                               index
                           );
                       }}
                       component={BasicInput}
                       sx={{
                           '& .MuiInputBase-root': {
                               marginTop: 0,
                           },
                           '& input': {
                               border: 'none !important'
                           }
                       }}
                   />
                   {index === 0 ? (
                       <div className={classes.addButtonStyle} onClick={appendEmail}>
                           <PlusIcon fill="#FFF" />
                       </div>
                   ) : (
                       <IconButton
                           size="small"
                           className=""
                           style={{ marginLeft: "5px" }}
                           onClick={() => {
                               removeMultiField("emails", index);
                           }}
                       >
                           <DeleteForever color="error" />
                       </IconButton>
                   )}
               </div>
           </Grid>
           ))
        }
      </Grid>

      <Grid
        container
        spacing={2}
        style={{ paddingInline: 5, marginBottom: 16, marginTop: 6 }}
      >
        {showAddress ? (
          <Grid item xs={12} style={{ paddingBottom: 0 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "2px",
                marginBottom: "8px"
              }}
            >
              <Button
                variant="contained"
                className={classes.manualEntryButton}
                onClick={toggleAddress}
                style={{
                  margin: 0,
                  padding: "6px 14px",
                  textTransform: "none",
                }}
              >
                Address Search
              </Button>
            </div>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <div
              className={classes.googlePlacesAutocomplete}
              style={{ margin: 0 }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "10px",
                  paddingTop: "4px",
                }}
              >
                <div style={{ width: "100%" }}>
                    <BasicFormControlWithLabelV2
                        label={'Address Search'}
                        fullWidth
                        apiKey={GOOGLE_API_KEY}
                        autoFocus={false}
                        autocompletionRequest={{
                            componentRestrictions: {
                                country: ["us", "ca"],
                            },
                        }}
                        selectProps={{
                            value,
                            onChange: async (e) => {
                                await handleAddress(e.value);
                            },
                            placeholder: (
                                <span
                                    style={{
                                        color: "rgb(8 40 82 / 42%)",
                                        fontSize: "15px",
                                    }}
                                >
                                  Start typing address here…
                                </span>
                            ),
                            classNamePrefix: "my-google-places-autocomplete",
                        }}
                        component={GooglePlacesAutocomplete}
                        sx={{
                            '& .my-google-places-autocomplete__control': {
                                border: 'none !important'
                            },
                            '& .my-google-places-autocomplete__control--is-focused, .my-google-places-autocomplete__control--menu-is-open' : {
                                boxShadow: 'none !important'
                            }
                        }}
                    />
                </div>
                <div style={{ width: "2px", paddingTop: "8px" }}>
                  <span
                    style={{
                      position: "relative",
                      marginLeft: "-80px",
                    }}
                  >
                    {IconList.locationSVG}
                  </span>
                </div>

                <Button
                  variant="contained"
                  className={classes.manualEntryButton}
                  onClick={toggleAddress}
                  style={{
                    whiteSpace: "nowrap",
                    paddingLeft: "14px",
                    paddingRight: "14px",
                    textTransform: "none",
                  }}
                >
                  Manual
                </Button>
              </div>
            </div>
          </Grid>
        )}
        {showAddress ? (
          <>
            <Grid item xs={12} style={{ paddingTop: "0px" }}>
                <BasicFormControlWithLabelV2
                    label={'Address'}
                    fullWidth
                    value={commercialContactForm.address}
                    onChange={(event) =>
                        handleInputField("address", event.target.value)
                    }
                    component={BasicInput}
                    sx={{
                        '& .MuiInputBase-root': {
                            marginTop: 0,
                        },
                        '& input': {
                            border: 'none !important'
                        }
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <BasicFormControlWithLabelV2
                    label={'City'}
                    fullWidth
                    value={commercialContactForm.city}
                    onChange={(event) =>
                        handleInputField("city", event.target.value)
                    }
                    component={BasicInput}
                    sx={{
                        '& .MuiInputBase-root': {
                            marginTop: 0,
                        },
                        '& input': {
                            border: 'none !important'
                        }
                    }}
                />
            </Grid>

            <Grid item xs={6}>
                <BasicFormControlWithLabelV2
                    label={'State'}
                    fullWidth
                    name="state"
                    defaultText="Please Select"
                    options={US_STATE_LIST}
                    value={getState(commercialContactForm.state) ? commercialContactForm.state : ""}
                    onChange={(event) => {
                        handleInputField("state", event.target.value)
                    }}
                    mapping={{
                        label: "label",
                        value: "value",
                    }}
                    component={BasicSelect}
                    sx={{
                        '& .MuiInputBase-root': {
                            marginTop: 0,
                        },
                        '& .MuiInputBase-input': {
                            border: 'none !important'
                        }
                    }}
                />
            </Grid>
            <Grid item xs={6}>.
                <BasicFormControlWithLabelV2
                    label={'Country'}
                    fullWidth
                    value={commercialContactForm.country}
                    onChange={(event) =>
                        handleInputField("country", event.target.value)
                    }
                    component={BasicInput}
                    sx={{
                        '& .MuiInputBase-root': {
                            marginTop: 0,
                        },
                        '& input': {
                            border: 'none !important'
                        }
                    }}
                />
            </Grid>

            <Grid item xs={6}>
                <BasicFormControlWithLabelV2
                    label={'Zip Code'}
                    fullWidth
                    value={commercialContactForm.zip}
                    onChange={(event) =>
                        handleInputField("zip", event.target.value)
                    }
                    component={BasicInput}
                    sx={{
                        '& .MuiInputBase-root': {
                            marginTop: 0,
                        },
                        '& input': {
                            border: 'none !important'
                        }
                    }}
                />
            </Grid>
          </>
        ) : (
          <Grid item xs={12} style={{ paddingTop: 0 }}>
            <div style={{ fontSize: "12px" }}>{makeAddress()}</div>
          </Grid>
        )}
      </Grid>

      <Grid
        container
        spacing={2}
        style={{ paddingInline: 5, marginBottom: "20px" }}
      >
        <Grid item xs={12} md={6}>
            <BasicFormControlWithLabelV2
                label={'Type of Business'}
                fullWidth
                name="businessType"
                options={BUSINESS_TYPE_OPTIONS}
                defaultText="Please Select"
                value={commercialContactForm.type_of_business}
                onChange={(event) => {
                    handleInputField("type_of_business", event.target.value);
                }}
                mapping={{
                    label: "title",
                    value: "value",
                }}
                component={BasicSelect}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& .MuiInputBase-input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={6}>
            <BasicFormControlWithLabelV2
                label={'FEIN #'}
                fullWidth
                value={commercialContactForm.fein}
                onChange={(event) => handleInputField("fein", event.target.value)}
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={6}>
            <BasicFormControlWithLabelV2
                label={'Business Classification'}
                fullWidth
                options={BUSINESS_CLASSIFICATION_OPTIONS}
                mapping={{
                    label: "display_name",
                    value: "id",
                }}
                defaultText="Please Select"
                placeholderText='Search Business Classification...'
                value={commercialContactForm.business_classification}
                onChange={(event) => {
                    handleInputField("business_classification", event.target.value);
                }}
                component={BasicSelectWithSearch}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& .MuiInputBase-input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={6}>
          <div>
            <div className="business_started_year_add_contact">
                <BasicFormControlWithLabelV2
                    label={'Year Business Started'}
                    component={DatePicker}
                    selected={commercialContactForm.year_business_started ? new Date(commercialContactForm.year_business_started) : null}
                    onChange={(date) => {
                        const year = date ? date.getFullYear().toString() : '';
                        handleInputField("year_business_started", year);
                    }}
                    showYearPicker
                    dateFormat="yyyy"
                    maxDate={new Date()}
                    className="react-datepicker-wrapper"
                    sx={{
                        '& .react-datepicker-wrapper input': {
                            border: 'none !important'
                        }
                    }}
                />
            </div>
          </div>
        </Grid>

        <Grid item xs={12} md={6}>
            <BasicFormControlWithLabelV2
                label={'Years of Management Experience'}
                type="number"
                fullWidth
                value={commercialContactForm.years_of_management_experience}
                onChange={(event) =>
                    handleInputField(
                        "years_of_management_experience",
                        event.target.value
                    )
                }
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={6}>
            <BasicFormControlWithLabelV2
                label={'Number of Employees'}
                type="number"
                fullWidth
                value={commercialContactForm.number_of_employees}
                onChange={(event) =>
                    handleInputField("number_of_employees", event.target.value)
                }
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={6}>
            <BasicFormControlWithLabelV2
                label={'Annual Revenue'}
                fullWidth
                value={commercialContactForm.annual_revenue}
                onChange={(event) =>
                    handleInputField("annual_revenue", event.target.value)
                }
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>

        <Grid item xs={12} md={6}>
            <BasicFormControlWithLabelV2
                label={'Total Payroll'}
                fullWidth
                value={commercialContactForm.total_payroll}
                onChange={(event) =>
                    handleInputField("total_payroll", event.target.value)
                }
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        </Grid>
      </Grid>
     </div>
    </div>
  );
};

export default ContactBusinessInfoTab;
